import { FormArray, ValidationErrors } from '@angular/forms';

export function nonEmptyFormArrayValidator(formArray: FormArray): ValidationErrors | null {
    return formArray && formArray.length > 0 ? null : { requiredTasks: true };
}
